<template>
    <div class="star-rating" v-if="showFullStars || showEmptyStars">
        <i class="fas fa-star star-rating__star" v-for="(star, key) in showFullStars" :key="'Full' + key"></i>
        <i class="fas fa-star-half-alt star-rating__star" v-if="rating % 1 != 0"></i>
        <i class="far fa-star star-rating__star" v-for="(star, key) in showEmptyStars" :key="'Empty' + key"></i>
    </div>
</template>

<script>
    export default {
        props: {
            rating: {
                type: Number,
                default: 0
            }
        },
        computed: {
            showFullStars() {
                return Math.floor(this.rating);
            },
            showEmptyStars() {
                return 5 - Math.ceil(this.rating);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .star-rating {
        display: flex;
        font-size: 14px;
        align-items: center;
        justify-content: center;

        @include media-breakpoint-up(sm) {
            justify-content: flex-start;
        }
        
        &__star {
            margin-right: 2px;
            color: $color-secondary;
        }
    }
</style>